module.exports = __webpack_public_path__ + "img/layout-1d2x.54bca0a3.jpg";